import * as React from 'react';

interface ExternalImageProps {
  imageLink: string | null;
  defaultSVG: React.ComponentType | null;
  dataTag?: string;
  className?: string;
  imageAlt: string;
}

export default class ExternalImage extends React.PureComponent<ExternalImageProps> {
  render() {
    const { imageLink, defaultSVG, dataTag, className, imageAlt } = this.props;
    if (imageLink) {
      return <img src={imageLink} className={className} data-it={dataTag} alt={imageAlt} />;
    }
    if (!!defaultSVG) {
      const Icon = defaultSVG;
      return <Icon data-it={dataTag} />;
    }
    return <div data-it={dataTag} />;
  }
}
